import PropTypes from "prop-types";
import styles from "./index.css";

const Icon = ({ icon, ...props }) => {
  const svg = require(`../icons/${icon}.svg`).default;

  return (
    <span {...props} className={styles.container}>
      <svg viewBox={svg.viewBox}>
        <use xlinkHref={`#${svg.id}`} />
      </svg>
    </span>
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;
